<div class="campo-icono" [class.deshabilitado]="deshabilitado">

  <span class="etiqueta">{{ etiqueta }}</span>

  <button type="button" class="caja" (click)="abrirSelector()" [disabled]="deshabilitado"
    [matTooltip]="icono ? 'Cambiar icono' : 'Elegir un icono'">

    <!-- Sin icono cargado se muestra el genérico apagado: deja claro que la
         pantalla va a mostrar algo, pero que todavía no lo eligieron -->
    <mat-icon class="muestra" [class.sin-elegir]="!icono" [color]="icono ? 'primary' : ''">
      {{ icono ? icono : iconoPorDefecto }}
    </mat-icon>

    <span class="nombre" *ngIf="icono">{{ icono }}</span>
    <span class="nombre vacio" *ngIf="!icono">Sin icono</span>

    <span class="spacer"></span>

    <mat-icon class="accion" *ngIf="icono && !deshabilitado" (click)="quitar($event)"
      matTooltip="Quitar icono">close</mat-icon>

    <mat-icon class="accion">edit</mat-icon>
  </button>

  <span class="ayuda" *ngIf="ayuda">{{ ayuda }}</span>
</div>
